<div class="order-details__list-item">
  <div class="detail-left-col">{{ 'FRONTEND.SALES_UI.TAGS' | translate }}</div>
  <div class="order-details__list-item__value">
    <div class="order-details__tag-container">
      <ng-container *ngIf="!isEditing; else editMode">
        <div *ngIf="tags && tags.length > 0; else noTags" class="order-details__tag">
          <div *ngFor="let tag of tags">
            <glxy-badge color="grey">
              <span>{{ tag }}</span>
            </glxy-badge>
          </div>
        </div>
        <ng-template #noTags>
          <div class="no-tags">{{ 'FRONTEND.SALES_UI.NO_TAGS' | translate }}</div>
        </ng-template>
        <button mat-icon-button (click)="editTags()" *ngIf="editable">
          <mat-icon>edit</mat-icon>
        </button>
      </ng-container>
    </div>

    <ng-template #editMode>
      <ng-container *ngIf="this.options$ | async as options; else loading">
        <ng-container *ngIf="!this.isSubmittingTags; else loading">
          <forms-input-tags
            class="tag-input"
            placeholder="{{ 'FRONTEND.SALES_UI.ADD_TAG' | translate }}"
            [options]="options.tags"
            [allowCustomTags]="true"
            [allowDuplicates]="false"
            [maxFields]="maxTags"
            [ngModel]="editingTags"
            [bottomSpacing]="'none'"
          ></forms-input-tags>
          <button mat-flat-button color="primary" (click)="sendTags()">
            {{ 'FRONTEND.SALES_UI.SAVE' | translate }}
          </button>
        </ng-container>
      </ng-container>
      <ng-template #loading>
        <div class="loading-indicator">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
